"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scandicci": {
    "f05f9782": [{
      "hkey": "83cdd5cf",
      "slug": "badia-a-settimo-san-colombano",
      "name": "Badia a Settimo-San Colombano",
      "primary": true,
      "skipSearch": false
    }],
    "badia-a-settimo": [{
      "hkey": "83cdd5cf",
      "slug": "badia-a-settimo-san-colombano",
      "name": "Badia a Settimo-San Colombano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d44f57db": [{
      "hkey": "9099900f",
      "slug": "la-bagnese-san-giusto",
      "name": "La Bagnese-San Giusto",
      "primary": true,
      "skipSearch": false
    }],
    "le-bagnese-san-giusto": [{
      "hkey": "9099900f",
      "slug": "la-bagnese-san-giusto",
      "name": "La Bagnese-San Giusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "44b38a10": [{
      "hkey": "e170e814",
      "slug": "scandicci",
      "name": "Scandicci",
      "primary": true,
      "skipSearch": false
    }],
    "roveta": [{
      "hkey": "e170e814",
      "slug": "scandicci",
      "name": "Scandicci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2d4a2344": [{
      "hkey": "0b1eb5f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "scandicci-centro": [{
      "hkey": "0b1eb5f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;